module.exports = __webpack_public_path__ + "593a3d53/img/copy-icon.408fdb2d.svg";